<template>
	<div class="container-product">
		<p class="typo-h5 mt-3">
			Product status
		</p>
		<div class="container-product-tabs">
			<BaseLoading v-if="isLoading" />
			<CTabs
				v-else
				:active-tab="activeIndex"
				class="custom-tabs"
				@update:activeTab="handleUpdateTab"
			>
				<CTab>
					<!-- render when tab index equal 0 -->
					<template slot="title">
						<span class="icon">
							New SKUs
						</span>
					</template>
					<div class="content">
						<DashboardProductStatusNewSku
							:items="newSkus"
						/>
					</div>
				</CTab>
				<CTab title="All SKU">
					<!-- render when tab index equal 1 -->
					<template slot="title">
						<span class="icon">
							Inactive SKUs
						</span>
					</template>
					<div class="content">
						<DashboardProductStatusInactiveSku
							:items="inactiveSkus"
						/>
					</div>
				</CTab>
			</CTabs>
		</div>
	</div>
</template>

<script>
import DashboardProductStatusNewSku from '../components/DashboardProductStatusNewSku.vue';
import DashboardProductStatusInactiveSku from '../components/DashboardProductStatusInactiveSku.vue';

export default {
	name: 'DashboardProductStatus',

	components: {
		DashboardProductStatusNewSku,
		DashboardProductStatusInactiveSku,
	},

	props: {
		isLoading: {
			type: Boolean,
			default: false,
		},
		activeTab: {
			type: Number,
			default: 0,
		},
		newSkus: {
			type: Array,
			default: () => [],
		},
		inactiveSkus: {
			type: Array,
			default: () => [],
		},
	},

	data() {
		return {
			activeIndex: 0,
		};
	},

	watch: {
		activeIndex() {
			this.$emit('update:activeTab', this.activeIndex);
			this.$emit('onTabChange', this.activeIndex);
		},
		activeTab() {
			this.activeIndex = this.activeTab;
		},
	},

	created() {
		this.activeIndex = this.activeTab;
	},

	methods: {
		handleUpdateTab(tabIndex) {
			this.activeIndex = tabIndex;
		},
	},
};
</script>

<style lang="scss" scoped>
.container-product {
	width: 100%;
	padding: rem(16);
	display: flex;
	flex-direction: column;
	background-color: $color-white;
	border-radius: 4px;
	box-shadow: $showdow-section;
}

.custom-tabs {
	::v-deep .nav-tabs {
		border-color: $color-gray-300;
	}

	.nav-item {
		width: rem(300);

		&:first-of-type {
			.icon::after {
				background-color: $color-success;
			}
		}

		&:last-of-type {
			.icon::after {
				background-color: $color-alert;
			}
		}

		::v-deep .nav-link {
			display: flex;
			flex-direction: column;
			justify-content: center;
			height: 100%;
			border-color: $color-gray-300;
			background-color: $color-gray-100;

			&.active {
				border-bottom: none;
				background-color: $color-white;
			}

			.icon {
				margin-top: rem(6);
				position: relative;
				padding-left: rem(20);
				font-size: rem($font-size-label);
				color: $color-black-90;
				font-weight: $font-weight-bold;

				&::after {
					content: "";
					position: absolute;
					top: rem(3);
					left: 0;
					width: rem(12);
					height: rem(12);
					border-radius: 50%;
				}
			}

			.value {
				font-size: rem($font-size-h4);
				color: $color-black-90;
				font-weight: $font-weight-bold;
			}
		}
	}

	::v-deep .tab-content {
		height: rem(438);
		overflow: auto;
		overflow-x: hidden;
		border: solid 1px $color-gray-300;
		border-top: none;
		margin-bottom: rem(30);
	}
}
</style>
